export { default } from './SlickCarouselSsr.vue';